import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const UserEmailNotFoundError = BaseErrorSchema.extend({
  errorType: z.literal('UserEmailNotFoundError'),
  email: z.string(),
});

export type UserEmailNotFoundError = z.infer<typeof UserEmailNotFoundError>;
